import Box from '@mui/material/Box'
import { FC } from 'react'

import EmptyStatePlaceholder from 'components/EmptyStatePlaceholder'
import WhiteBoxContainer from 'components/WhiteBoxContainer'
import ChartIllustration from 'images/chart.png'
import NewCalculationDropdown from 'views/CalculateEmissions/NewCalculationDropdown'
import { NavigationSource } from 'views/CalculateEmissions/Shared/BackButtonWithFromState'

const EmptyAnalyticsSection: FC = () => {
    return (
        <WhiteBoxContainer
            sx={{
                p: 3,
                mb: 3 / 2,
            }}
        >
            <EmptyStatePlaceholder
                illustration={ChartIllustration}
                title={'Nothing to show here'}
                description={
                    <Box sx={{ textAlign: 'center' }}>
                        No emissions data matches your current filters. <br />
                        Adjust your filters or create a new calculation to see results here.
                    </Box>
                }
                extra={<NewCalculationDropdown from={NavigationSource.ANALYTICS} />}
            />
        </WhiteBoxContainer>
    )
}

export default EmptyAnalyticsSection
